import { useState, useEffect } from 'react'

const useViewport = (): { isMobile: boolean } => {
  const [isMobile, setIsMobile] = useState<boolean>(typeof window !== 'undefined'
    ? window.innerWidth < 992 : false)

  useEffect(() => {
    const resizeListener = (): void => {
      setIsMobile(typeof window !== 'undefined' ? window.innerWidth < 992 : false)
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', resizeListener)
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', resizeListener)
      }
    }
  }, [])

  return { isMobile }
}
export default useViewport
